// extracted by mini-css-extract-plugin
export default {"watch-button":"_1EGnZ","watchButton":"_1EGnZ"};